import { render, staticRenderFns } from "./TraxUiCardPlainHeaderWithActions.vue?vue&type=template&id=1d8a4c03"
import script from "./TraxUiCardPlainHeaderWithActions.vue?vue&type=script&lang=js"
export * from "./TraxUiCardPlainHeaderWithActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports